import { render, staticRenderFns } from "./QutaEditMain.vue?vue&type=template&id=8cecf536&scoped=true&"
import script from "./QutaEditMain.vue?vue&type=script&lang=js&"
export * from "./QutaEditMain.vue?vue&type=script&lang=js&"
import style0 from "./QutaEditMain.vue?vue&type=style&index=0&id=8cecf536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cecf536",
  null
  
)

export default component.exports